export const arrowKeys = {
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  ArrowUp: 'up'
};
export const daysPerWeek = 7;
export const monthsPerYear = 12;
export const blankStringArray = [];